<mat-card
    class="buy-sell-plan-details"
    role="region"
    [attr.aria-label]="'BuySellRequestForm' | translate: {Default: 'Buy/Sell Request'}">
    <mat-card-content>
        <app-approval-status-card [buySellPlanEmployee]="buySellPlanEmployee"></app-approval-status-card>

        <dl class="detail-list" [attr.aria-label]="'PlanDetails' | translate: {Default: 'Plan Details'}">
            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective [localizationCode]="'OutstandingHours'">
                    {{ 'OutstandingHours' | translate: {Default: "Outstanding Hours"} }}
                </dt>
                <dd class="value">{{ employeeTimeOffType?.availableHours }}</dd>
            </div>

            <ng-container *ngIf="buySellPlan?.displayFutureAccrual === true && buySellPlanEmployee?.futureAccruals?.length">
                <div class="detail-row">
                    <dt class="label" appLocalizationPopupDirective [localizationCode]="'FutureAccruals'">
                        {{ 'FutureAccruals' | translate: {Default: "Future Accruals"} }}
                    </dt>
                    <dd class="value">
                        <ul class="accruals-list" [attr.aria-label]="'FutureAccruals' | translate: {Default: 'Future Accruals'}">
                            <li *ngFor="let accrual of buySellPlanEmployee?.futureAccruals">
                                {{ accrual.date | date:'mediumDate' }}: {{ accrual.amount }}
                            </li>
                        </ul>
                    </dd>
                </div>
            </ng-container>

            <div class="detail-row">
                <dt class="label" appLocalizationPopupDirective [localizationCode]="'HourlyCost'">
                    {{ 'HourlyCost' | translate: {Default: "Hourly Cost"} }}
                </dt>
                <dd class="value">{{ compensation?.payRateCurrency?.id | currencyDisplay: buySellPlanEmployee?.hourlyCost }}</dd>
            </div>
        </dl>

        <mat-form-field appearance="fill" appLocalizationPopupDirective [localizationCode]="'RequestType'">
            <mat-label id="request-type-label">{{ 'RequestType' | translate: {Default: "Type"} }}</mat-label>
            <mat-select
                [(ngModel)]="selectedType"
                (selectionChange)="hoursInput = 0"
                [attr.aria-labelledby]="'request-type-label'"
                [attr.aria-required]="true">
                <mat-option value="BUY">{{ 'Buy' | translate: {Default: 'Buy'} }}</mat-option>
                <mat-option value="SELL">{{ 'Sell' | translate: {Default: 'Sell'} }}</mat-option>
            </mat-select>
        </mat-form-field>

        <div *ngIf="selectedType" class="detail-row">
            <span class="label" appLocalizationPopupDirective [localizationCode]="'AvailableHours'" id="available-hours-label">
                {{ 'AvailableHours' | translate: {Default: "Available Hours"} }}
            </span>
            <span class="value" [attr.aria-labelledby]="'available-hours-label'" aria-live="polite" aria-atomic="true">
                {{
                (selectedType === 'BUY'
                ? buySellPlanEmployee?.maximumBuyHours
                : buySellPlanEmployee?.maximumSellHours) || '0'
                }}
            </span>
        </div>

        <mat-form-field appearance="fill" *ngIf="selectedType" appLocalizationPopupDirective [localizationCode]="'NumberOfHours'">
            <mat-label id="hours-input-label">{{ 'NumberOfHours' | translate: {Default: "Number Of Hours"} }}</mat-label>
            <input matInput type="number"
                [attr.aria-labelledby]="'hours-input-label'"
                [attr.aria-required]="true"
                [max]="(selectedType === 'BUY' ? buySellPlanEmployee?.maximumBuyHours : buySellPlanEmployee?.maximumSellHours) || 0"
                [min]="0"
                [(ngModel)]="hoursInput">
        </mat-form-field>

        <div *ngIf="selectedType" class="detail-row">
            <span
                *ngIf="selectedType === 'BUY'"
                class="label"
                id="salary-impact-label"
                appLocalizationPopupDirective [localizationCode]="'SalaryDeduction'">
                {{ 'SalaryDeduction' | translate: {Default: "Salary Deduction"} }}
            </span>
            <span
                *ngIf="selectedType === 'SELL'"
                class="label"
                id="salary-impact-label"
                appLocalizationPopupDirective [localizationCode]="'SalaryAddition'">
                {{ 'SalaryAddition' | translate: {Default: "Salary Addition"} }}
            </span>
            <span class="value" [attr.aria-labelledby]="'salary-impact-label'" aria-live="polite" aria-atomic="true">
                {{ compensation?.payRateCurrency?.id | currencyDisplay: hoursInput * buySellPlanEmployee?.hourlyCost }}
            </span>
        </div>
    </mat-card-content>

    <mat-card-actions role="group" [attr.aria-label]="'FormActions' | translate: {Default: 'Form Actions'}">
        <button
            type="button"
            appLocalizationPopupDirective [localizationCode]="'SubmitRequest'"
            mat-raised-button
            setColor="primaryColour"
            color="primary"
            [disabled]="hoursInput < 1"
            [attr.aria-disabled]="hoursInput < 1"
            appPreventDoubleClick
            (throttledClick)="onSubmit()">
            {{ 'SubmitRequest' | translate: {Default: "Submit Request"} }}
        </button>
    </mat-card-actions>
</mat-card>